module.exports = __webpack_public_path__ + "static/media/WorkButton.0810c30e.png";